export default __webpack_public_path__ + "static/media/loginLogo.06fd2f2c.svg";